import useAutoGrowTextField from '../../hooks/useAutoGrowTextField';

// Unstyled textarea that grows vertically to fit its text; callers supply the look,
// so it serves both the bordered form field and the borderless inline studio cells.
const XAutoGrowTextarea = ({
  value,
  onChange,
  onKeyDown,
  minHeight,
  singleLine = false,
  textareaRef,
  rows = 1,
  ...props
}) => {
  const { ref, handleChange, handleKeyDown } = useAutoGrowTextField({
    value,
    minHeight,
    onChange,
    onKeyDown,
    singleLine,
    externalRef: textareaRef,
  });

  return (
    <textarea
      ref={ref}
      rows={rows}
      value={value ?? ''}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      {...props}
    />
  );
};

export default XAutoGrowTextarea;
